/**
 * crm-app API 根路径（唯一配置见 src/pages/car/js/config.js）
 */
export {
	APP_API_BASE,
	H5_API_ENV,
	H5_LOCAL_API_BASE,
	H5_PRODUCTION_API_BASE,
	resolveH5AppApiBase
} from '@/pages/car/js/config.js'
